import { Check } from 'lucide-react';

export default function StepProgress({ steps, current }) {
  return (
    <div className="ees-container py-4 sm:py-6" data-testid="step-progress">
      <div className="flex items-center justify-between gap-1">
        {steps.map((s, i) => (
          <div key={i} className="flex items-center flex-1 last:flex-none">
            <div className="flex flex-col items-center">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold border-2 transition-colors ${
                  i < current
                    ? 'bg-[#9ec043] border-[#9ec043] text-white'
                    : i === current
                    ? 'border-[#9ec043] text-[#9ec043] bg-white'
                    : 'border-gray-300 text-gray-400 bg-white'
                }`}
                data-testid={`step-indicator-${i}`}
              >
                {i < current ? <Check className="w-4 h-4" /> : i + 1}
              </div>
              <span className={`text-[10px] sm:text-xs mt-1 text-center leading-tight max-w-[60px] sm:max-w-[80px] ${
                i <= current ? 'text-gray-700' : 'text-gray-400'
              }`}>
                {s.label}
              </span>
            </div>
            {i < steps.length - 1 && (
              <div className={`flex-1 h-0.5 mx-1 sm:mx-2 mt-[-16px] ${
                i < current ? 'bg-[#9ec043]' : 'bg-gray-200'
              }`} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
